import React, { useState } from 'react';

import { Button } from 'components/ui/button';
import { Errors } from 'components/ui/errors';
import { Field } from '@buildoutinc/blueprint-react/ui/Field';
import { Input } from '@buildoutinc/blueprint-react/ui/Input';
import { Modal } from '@buildoutinc/blueprint-react/ui/Modal';
import { digitsIn, messageFor } from './helpers';
import { post } from 'helpers/api';

import type { PhoneEnrollment } from 'components/users/types';

interface Props {
  number: string;
  path: string;
  onClose: () => void;
  onConfirmed: (enrollment: PhoneEnrollment) => void;
}

export function ConfirmationForm({ number, path, onClose, onConfirmed }: Props) {
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function confirmCode() {
    setBusy(true);
    setError(null);

    try {
      const enrollment: PhoneEnrollment = await post(path, { code });
      onConfirmed(enrollment);
    } catch (thrown) {
      setError(messageFor(thrown));
      setCode('');
    } finally {
      setBusy(false);
    }
  }

  function handleCodeChange(event: React.ChangeEvent<HTMLInputElement>) {
    setCode(event.target.value);
  }

  const submittable = digitsIn(code) === 6;

  return <>
    <Modal.Header>
      <Modal.Title>Confirm your phone</Modal.Title>
    </Modal.Header>

    <Modal.Body>
      <Field className="form-group">
        <Field.Label htmlFor="phoneEnrollmentCode">Confirmation code</Field.Label>
        <Input
          autoComplete="one-time-code"
          id="phoneEnrollmentCode"
          inputMode="numeric"
          value={code}
          onChange={handleCodeChange}
        />
        <Field.Description>{`Sent to ${number || 'your phone'}.`}</Field.Description>
      </Field>

      <Errors error={error} />
    </Modal.Body>

    <Modal.Footer>
      <Button disabled={busy} label="Cancel" variant="ghost" onClick={onClose} />
      <Button disabled={busy || !submittable} label="Confirm" onClick={confirmCode} />
    </Modal.Footer>
  </>;
}
